import ChessClassicSvg from '@/assets/icons/classic.svg?component';
import ChessClassicSmallSvg from '@/assets/icons/classic-small.svg?component';

export default {
  name: 'IconChessClassic',
  components: { ChessClassicSvg, ChessClassicSmallSvg },
  props: {
    color: { type: String, default: 'rgb(0,0,0)' },
    size: { type: String, default: '1em' },
    width: { type: String, default: null },
    height: { type: String, default: null },
    tooltipEnabled: { type: Boolean, default: true },
  },
  computed: {
    sizeValue() {
      const parsed = Number.parseFloat(String(this.size).replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : null;
    },
    isSmallSize() {
      return this.sizeValue !== null && this.sizeValue <= 14;
    },
    svgComponent() {
      return this.isSmallSize ? 'ChessClassicSmallSvg' : 'ChessClassicSvg';
    },
    viewBox() {
      return this.isSmallSize ? '0 0 438 438' : '-12 -12 462 462';
    },
    svgStyle() {
      return {
        height: this.height || this.size,
        width: this.width || 'auto',
        color: this.color,
        display: 'block',
      };
    },
    tooltipOptions() {
      return {
        value: this.$t('chessVariants.classic'),
        class: 'tt-sm',
        disabled: !this.tooltipEnabled,
      };
    },
  },
};
